import React from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

export const LegacyLoginHelpLink = () => {
  const useSignUpMigration = useSelector(state => state.loginForm.useSignUpMigration === true);
  const legacyLoginLink = useSelector(state => state.loginForm.legacyLoginLink);

  if (!useSignUpMigration || !legacyLoginLink) {
    return null;
  }

  return (
    <div>
      <div className="mb-5 mt-0 border-t border-neutral-300" />
      <a
        id="legacyLoginHelpLink"
        href={legacyLoginLink}
        className="block w-full rounded bg-accent-600 px-4 py-2 text-center text-lg font-medium text-white shadow-sm transition-colors duration-150 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <FormattedMessage
          id="login.havingTrouble"
          defaultMessage="Having trouble? Use the classic login"
          description="Link text that sends users to legacy login during sign-up migration"
        />
      </a>
    </div>
  );
};
